export class ScreenTimeSlot {
  startTime: string;
  endTime: string;
  constructor(startTime?: string, endTime?: string) {
    this.startTime = startTime || '00:00';
    this.endTime = endTime || '00:00';
  }
}
